import { IoQrCodeOutline } from "react-icons/io5";
import { useState } from "react";
import { useTranslation } from "react-i18next";


function TableAssignedTooltip() {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();

  return (
    <span
      className={` relative  z-50 block cursor-pointer rounded-full bg-green-400 p-1 text-green-700`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IoQrCodeOutline size={15} />

      {isHovered && (
        <span
          className={`absolute    -top-10 right-0 z-50 w-max max-w-[200px] rounded bg-green-200 px-3 py-2 text-center text-xs font-semibold text-green-800 shadow-md`}
        >
          {t("tableQrStatus.tableAssigned")} {/* or custom content you’ll write */}
        </span>
      )}
    </span>
  );
}

export default TableAssignedTooltip;
